import React from 'react'
import { LegalPage } from '@/components/legal/LegalPage'

export const CookiesPage: React.FC = () => (
  <LegalPage
    titleKey="legal.cookies.title"
    sections={[
      { titleKey: 'legal.cookies.introTitle', contentKey: 'legal.cookies.intro' },
      { titleKey: 'legal.cookies.whatTitle', contentKey: 'legal.cookies.what' },
      { titleKey: 'legal.cookies.typesTitle', contentKey: 'legal.cookies.types' },
      { titleKey: 'legal.cookies.legalBasisTitle', contentKey: 'legal.cookies.legalBasis' },
      { titleKey: 'legal.cookies.managementTitle', contentKey: 'legal.cookies.management' },
      { titleKey: 'legal.cookies.moreInfoTitle', contentKey: 'legal.cookies.moreInfo' },
    ]}
  />
)
